export default {
    confirmation: {
        loading: false,
        error: false,
        warning: false,
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/introduction/state.js